module.exports = __webpack_public_path__ + "img/cns_printer_mac16.910ce1d9.png";